import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  padding: 150px 0;
  background: ${(props) => props.theme.color.blue.light};

  ${mediaQuery('small')} {
    padding: 30px 0;
  }
`;
